<template>
  <v-layout justify-center>
    <loading :active.sync="busy"/>

    <v-dialog v-model="dialog_status"
      class="dialog-container"
      persistent max-width="290px"
      scrollable
      @keydown.esc="close()">

      <v-card>
        <v-card-title>
          {{ $t('fork_doc.fork_document') }}
        </v-card-title>
        
        <v-card-text v-if="!fork_success">
          <div class="meta">{{ $t('fork_doc.select_project') }}</div>
          <v-radio-group class="small-radio"
            v-model="fork_proj_id">
            <v-radio v-for="value in projects"
              :key="value.proj_id"
              :label="value.title"
              :value="parseInt(value.proj_id)">
            </v-radio>
          </v-radio-group>
          <div v-if="error">
            <div class="message-error">
              {{ error_message }}
            </div>
          </div>
        </v-card-text>

        <v-card-text v-else>
         {{ $t('fork_doc.complete') }}
        </v-card-text>

        <v-card-actions v-if="!fork_success">
          <v-spacer></v-spacer>
          <v-btn small text @click="close()">
            {{ $t('fork_doc.close') }}
          </v-btn>
          <v-btn small depressed color="primary" 
            :disabled="!confirm||disabled"
            @click="forkDocument()">
            {{ $t('fork_doc.fork') }}
          </v-btn>
        </v-card-actions>

        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn small text @click="close()">
            {{ $t('fork_doc.close') }}
          </v-btn>
          <v-btn small depressed color="primary" @click="getProject()">
            {{ $t('fork_doc.go_project') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },

    dockey: {
      type: String,
      // required: true,
    }
  },
  
  data() {
    return {
      busy: false,

      fork_success: false,
      fork_proj_id: null,

      error: false,
      error_message: "",

      disabled: false,
    }
  },

  computed: {
    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },

    ...mapGetters({
      projects: 'project/projects',
    }),

    confirm() {
      return !!this.fork_proj_id
    },
  },

  watch: {
    fork_proj_id: {
      handler(val) {
        this.error = false
      },
      immediate: true
    },
  },

  methods: {
    close() {
      this.reset()
      this.$emit('update:dialog', false)
    },

    reset() {
      this.fork_success = null
      this.fork_proj_id = null
      this.$emit('update:dockey', "")
    },

    async forkDocument() {
      if (this.disabled) return
      this.busy = true
      this.disabled = true
      try {
        await this.$store.dispatch('project/getDocumentsInProject', {
          proj_id: this.fork_proj_id
        })
      } catch(e) {
        this.error = true
        this.error_message = this.$t('alert.try_again')
      } finally {
          if (!this.error) {
            let keys = this.$store.getters['project/documents'].map(v => v.key)
            if (keys.includes(this.dockey)) {
              this.error = true
              this.error_message = this.$t('fork_doc.already')
              this.busy = false
            } else {
              try {
                await this.$store.dispatch('project/addDocumentsToProject', {
                  proj_id: this.fork_proj_id,
                  documents: [this.dockey]
                })
              } catch(e) {
                this.error = true
                this.error_message = this.$t('alert.try_again')
              } finally {
                if (!this.error) {
                  this.fork_success = true
                  this.fork_proj_id = this.fork_proj_id
                  this.$analytics.logEvent('click', { name: 'piece_btn_forkDoc' })
                }
                this.busy = false 
              }
          }
        }
        else { this.busy = false }
        setTimeout(() => {
          this.disabled = false
        }, 500)
      }
    },

    getProject() {
      this.$router.push({name: 'project', 
        params: {id: this.fork_proj_id},
        query: { doc: this.dockey }})
    },
  }
}
</script>

<style scoped>
  .meta {
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/gallery/ForkDocument.vue